function isIndeterminate(row) {
    const { childList, buttonList, isChecked, isLeaf } = row;
    let iter = isLeaf ? buttonList: childList
    if (iter ?.length > 1) {
        for (const item of iter) {
            if (item.isChecked !== isChecked) return true;
        }
    }
    return false;
}
function traverseTree(data, routeCb = () => {}, leafCb = () => {}) {
    if (!Array.isArray(data)) return
    data.forEach(item => {
        routeCb(item)
        if (item.isLeaf) leafCb(item)
        traverseTree(item.childList, routeCb, leafCb)
    })
}

function notifyParent(data,pid, enableIndeteriminate = false) {
    traverseTree(data, route => {
        if (route.permissionId === pid) {
            const length = (route.childList || []).filter(item => item.isChecked).length
            length > 0 || !enableIndeteriminate ? route.isChecked = 1 : route.isChecked = 0
            notifyParent(data, route.pid)
        }
    }, leaf => {
        if (leaf.permissionId === pid) {
            const length = (leaf.buttonList||[]).filter(item => item.isChecked).length
            length > 0 || !enableIndeteriminate ?  leaf.isChecked =  1 : leaf.isChecked = 0
            notifyParent(data, leaf.pid)
        }
    })
}
export default {
    data: () => {
        return {
            moduleTree: [],
        }
    },
    computed: {
        submitList() {
            const newarr = []
            this.getTreeDataByFilter(this.moduleTree, newarr);
            return newarr
        },
        // 扁平化
        flatModuleList() {
            const { moduleTree } = this;
            const list = [];
            const each = childList => {
            for (const module of childList) {
                list.push(module);
                const { childList } = module;
                if (childList && childList.length > 0) each(childList);
            }
            };
            each(moduleTree);
            return list;
        }
    },
    methods: {
        /** 刷新全局CheckBox状态 */
        refreshCheckboxStatus(data, enableIndeteriminate = false) {
            if (!Array.isArray(data)) return
            data.forEach(item => {
                item.indeterminate = enableIndeteriminate ? isIndeterminate(item) : false
                this.refreshCheckboxStatus(item.childList)
            })
        },

        checkPermissionClass(row, enableNotifyParent = true, enableIndeteriminate = false) {
            const { isChecked, permissionId, pid } = row
            enableNotifyParent && notifyParent(this.moduleTree, pid, enableIndeteriminate)
            const eacher = l => {
                l.indeterminate = false
                l.isChecked = isChecked
            }
            let node = null
            traverseTree(this.moduleTree, (current) => {
                if (current.permissionId === permissionId) {
                    node = current
                }
            })
            if (node) {
                traverseTree([node], eacher, (leaf) => {
                    leaf?.buttonList?.forEach(eacher)
                })
            }
            this.refreshCheckboxStatus(this.moduleTree, enableIndeteriminate)
        },

        checkPermissionButton(row, enableNotifyParent = true, enableIndeteriminate = false) {
            const { pid } = row
            enableNotifyParent && notifyParent(this.moduleTree, pid, enableIndeteriminate)
            this.refreshCheckboxStatus(this.moduleTree)
        }
    }
}